import React from "react";
import "../TemplateComponents/helpers/style.css";

const ButtonForm = ({ data }) => {
  const { values } = data;

  return (
    <div className="control_padding">
      <div>
        {values &&
          values.length > 0 &&
          values?.map((item, ind) => (
            <button
              className="important-border"
              style={{
                "--border-color": item?.borderColor,
                background: item?.background,
                height: item?.ySize,
                width: item?.xSize,
                opacity: item?.opacity,
                position: item?.xPosition ? "absolute" : "relative",
                top: item?.xPosition ? item.xPosition : "0px",
                [item?.align || "left"]: item?.yPosition
                  ? item.yPosition
                  : "0px",
                fontFamily: item?.buttonFont || "inherit",
                fontSize: item?.buttonFontSize || "inherit",
                borderRadius: `${item?.buttonRounding}px` || "0px",
              }}
              key={ind}
            >
              {item?.text ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.text, 
                  }}
                  style={{ fontSize: item?.buttonFontSize, marginBottom:0  }}
                  className="editor-inner-text"
                />
              ) : (
                "Button"
              )}
            </button>
          ))}
      </div>
    </div>
  );
};

export default ButtonForm;
